import { render } from "./Niif.vue?vue&type=template&id=051ab5f9&scoped=true"
import script from "./Niif.vue?vue&type=script&lang=js"
export * from "./Niif.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./Niif.vue?vue&type=style&index=1&id=051ab5f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051ab5f9"]])

export default __exports__